import { ILogItem } from './LoggerTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ILoggerState {
    logs: ILogItem[],
    isConnected: boolean,
    serverState: string,
    deviceState: string,
    deviceDisplayState: string,
    deviceSpeechState: string,
}

const initialState: ILoggerState = {
    logs: [],
    serverState: "",
    deviceState: "",
    deviceDisplayState: "",
    deviceSpeechState: "",
    isConnected: false
};
// action: PayloadAction<HomeLayout>
export const loggerSlice = createSlice({
    name: "logger",
    initialState,
    reducers: {
        setLogs: (state, action: PayloadAction<ILogItem[]>) => {
            state.logs = action.payload;
        },
        addLog: (state, action: PayloadAction<ILogItem>) => {
            const newLog = action.payload;
            state.logs = [...state.logs, newLog];

            if (newLog.value)
                if (newLog.source === "device") {
                    if (newLog.type === "display_state") state.deviceDisplayState = newLog.value;
                    if (newLog.type === "speech_state") state.deviceSpeechState = newLog.value;
                    if (newLog.type === "state") state.deviceState = newLog.value;
                } else if (newLog.source === "server") {
                    if (newLog.type === "state") state.serverState = newLog.value;

                }

        },
        setIsConnected: (state, action: PayloadAction<boolean>) => {
            state.isConnected = action.payload;
        }

    },
});

export const { setLogs, addLog, setIsConnected } = loggerSlice.actions;

export default loggerSlice.reducer;
